import { render, staticRenderFns } from "./PFormSelect.vue?vue&type=template&id=042ed16e&scoped=true"
import script from "./PFormSelect.vue?vue&type=script&lang=ts"
export * from "./PFormSelect.vue?vue&type=script&lang=ts"
import style0 from "./PFormSelect.vue?vue&type=style&index=0&id=042ed16e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042ed16e",
  null
  
)

export default component.exports